import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { register as register } from '@bigyellow/api/register'
import { handle_api_exception } from '@bigyellow/api/exception'
import { withStore } from '@bigyellow/store'
import { token } from '@bigyellow/api/auth'
import EnterMobileNumberForm from '@bigyellow/components/SignIn/EnterMobileNumberForm'
import EnterMobileCodeForm from '@bigyellow/components/SignIn/EnterMobileCodeForm'

const AuthByMobileNumber = ({ store, user, onComplete, onCancel, disablePhoneNumberEdit = false }) => {
  const [isRequestSent, setIsRequestSent] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [debugData, setDebugData] = useState(null)
  const [mobileNumber, setMobileNumber] = useState(user.mobileNumber)

  useEffect(() => {
    if (!mobileNumber) {
      setMobileNumber(user.mobileNumber)
    }
  }, [user])

  const requestMobileAuth = (phoneNumber) => {
    const http_client = store.get('http_client')
    const notify = store.get('notify')
    setSubmitting(true)

    register(http_client, {
      customerId: user.customerId,
      email: user.email,
      mobileNumber: phoneNumber,
      password: user.password
    }).then((res) => {
      setDebugData(res.data?.debug)
      setIsRequestSent(true)
    }).catch((err) => {
      notify(handle_api_exception(err), { type: 'error' })
    }).finally(() => {
      setSubmitting(false)
    })
  }

  const authenticateUser = (code) => {
    setSubmitting(true)
    const http_client = store.get('http_client')
    const notify = store.get('notify')
    token(http_client, { code: code }).then((res) => {
      const { data, code } = res.data
      if (code === 200) {
        onComplete(data)
      } else {
        alert('Oooops. There was a problem.')
      }
    }).catch((err) => {
      if (notify) {
        notify(handle_api_exception(err), { type: 'error' })
      }
    }).finally(() => {
      setSubmitting(false)
    })
  }

  const EditDisabledMessage = () => {

    const lastFourDigits = mobileNumber.slice(-3)
    return <React.Fragment>
      <Row className={'mb-4'}>
        <Col>
          <p>
            Click the button below to receive a new verification code to the number ending {lastFourDigits}.
          </p>
        </Col>
      </Row>
      <Row className={'my-1'}>
        <Col className={`text-center`}>
          <Button
            type="button"
            className="btn btn-primary btn-block"
            onClick={() => {
              requestMobileAuth(mobileNumber)
            }}
          >
            Continue
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  }

  return (
    <React.Fragment>
      <div className={'text-center mb-4'}>
        {isRequestSent ? <>
          <EnterMobileCodeForm
            onComplete={(code) => authenticateUser(code)}
            disabled={submitting}
            debugCode={debugData?.code}
            mobileNumber={mobileNumber}
          />
          <Button
            variant="link"
            onClick={() => requestMobileAuth(mobileNumber)}
            disabled={submitting}
          >
            Resend verification code
          </Button>
          {!disablePhoneNumberEdit &&
            <Button
              variant="link"
              onClick={() => setIsRequestSent(false)}
              disabled={submitting}
            >
              Change mobile number
            </Button>
          }

        </> : (disablePhoneNumberEdit ? <EditDisabledMessage /> : <EnterMobileNumberForm disabled={submitting}
                                                                                         onComplete={(inMobileNumber) => {
                                                                                           setMobileNumber(inMobileNumber);
                                                                                           requestMobileAuth(inMobileNumber)
                                                                                         }} />)}
        <Button
          variant="link"
          onClick={onCancel}
          disabled={submitting}
        >
          Select a different method
        </Button>
      </div>
    </React.Fragment>
  )
}

export default withStore(AuthByMobileNumber)